"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var text_1 = __importDefault(require("relements/build/esm/ui/text"));
var modal_1 = __importDefault(require("relements/build/esm/overlays/modal"));
var icon_1 = __importDefault(require("relements/build/esm/ui/icon"));
require("./ModalV2.scss");
var defaults = {
    active: false,
    title: '',
    subtitle: '',
    toggleModal: function () { return null; },
    children: react_1["default"].createElement("div", null),
    classPrefix: 'modalV2',
    headerIcon: null,
    headerSubIcon: null,
    isV2: false,
};
var ModalV2 = function (_a) {
    var _b = _a === void 0 ? defaults : _a, active = _b.active, toggleModal = _b.toggleModal, title = _b.title, subtitle = _b.subtitle, children = _b.children, classPrefix = _b.classPrefix, headerIcon = _b.headerIcon, headerSubIcon = _b.headerSubIcon, isV2 = _b.isV2, className = _b.className, redirectInfo = _b.redirectInfo;
    return (react_1["default"].createElement(modal_1["default"], { active: active && isV2, prefixClassName: classPrefix, className: className },
        react_1["default"].createElement(modal_1["default"].Header, { prefixClassName: "modalV2-header", customCloseIcon: "closeV2", onClose: toggleModal },
            react_1["default"].createElement("div", { className: "modalV2-header-title" },
                react_1["default"].createElement("div", { className: "title" },
                    headerIcon && (react_1["default"].createElement(icon_1["default"], { className: "modalV2-header-icon-left", src: headerIcon })),
                    react_1["default"].createElement(text_1["default"], { variant: "h2.semi-bold" }, title)),
                redirectInfo && redirectInfo,
                subtitle && (react_1["default"].createElement("div", { className: "subtitle" },
                    headerSubIcon && (react_1["default"].createElement(icon_1["default"], { className: "modalV2-header-icon-left", src: headerSubIcon })),
                    react_1["default"].createElement("span", null, subtitle))))),
        react_1["default"].createElement("div", { className: "modalV2-content" },
            react_1["default"].createElement("div", { className: "modalV2-content-wrapper" }, children))));
};
exports["default"] = ModalV2;
